import { parseUrl } from './url';
import { isApp } from '@spot-fe/utils';

export const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';

export const referrerPath = () => {
    if (!document.referrer) return '';
    return parseUrl(document.referrer).pathname;
};

export const isServer = () => typeof window === 'undefined';


export const detectAvifSupported = () => {
    if (!isServer()) {
      const img = new Image();
      img.src =
        'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
      return img.decode
        ? img
            .decode()
            .then(() => true)
            .catch(() => false)
        : Promise.resolve('decode' in img);
    } else {
      return Promise.resolve(false);
    }
};
  
export const checkAccountToRegister = (source) => {
  const link = `/register?source=${source}`;
  const isNewUser = (window as any)?.sensors?.getPresetProperties?.()
    ?.identities?.$identity_login_id;
  if (!isApp() && !isNewUser) {
    window.location.href = link;
    return true;
  }

  return false;
};

